import DelMessageForMicroapp from './components/del-message-for-microapp';
import MaterialSettings from '../../../components/material-settings';
import ShopGeneralView from '../../../components/shop-general-view';
import Container from '@/components/container';
import { getQuery } from '@/common/utils';
import DailyGoodsDetail from './../daily-goods-detail';
import DailyGoodsStrategyRangeSet from './../daily-goods-strategy-rangeSet';

export default [
  {
    title: '触达商品完善情况',
    path: '/touch-state',
    component: () => (
      <Container>
        <ShopGeneralView />
      </Container>
    ), //嵌入提报
    getLink({ path, search = '' }) {
      return `${path}${window.location.search}`;
    },
  },
  {
    title: '素材维护触达设置',
    path: '/touch-set',
    component: () => (
      <Container>
        <MaterialSettings disabled />
      </Container>
    ), //嵌入提报
    getLink({ path, search = '' }) {
      return `${path}${window.location.search}`;
    },
  },
  {
    title: '触达商品范围',
    path: '/touch-range',
    component: () => {
      // noticeScope:
      // 0 - 全量触达 - 商运页面
      // 1 - 部分触达 - 投放页面
      const noticeScope = getQuery('noticeScope');
      return (
        <DelMessageForMicroapp>
          {noticeScope == 0 ? (
            <DailyGoodsDetail urlHash={'#/flow-field/field-inventory-view'} disable />
          ) : (
            <DailyGoodsStrategyRangeSet disable />
          )}
        </DelMessageForMicroapp>
      );
    },
    getLink({ path, search = '' }) {
      // noticeScope:
      // 0 - 全量触达 - 商运页面 不可编辑：http://wareops.man.jd.com/#/flow-field/field-inventory-view?promotionActivityId=${roomId}&jid=${jid}&createdBy=${createdBy}
      // 1 - 部分触达 - 投放页面 不可编辑：https://beta-ace.jd.com/pandora/#/integration/yx-promotion?outId=xxx&activityType=11&uniqueId=xxx&ruleId=xxxx&disable=true
      const noticeScope = getQuery('noticeScope');
      const activityId = getQuery('activityId');
      const roomId = getQuery('roomId');
      const jid = getQuery('jobId');
      const ruleId = getQuery('ruleId');
      if (noticeScope == 0) {
        return `${path}${window.location.search}#/flow-field/field-inventory-view?promotionActivityId=${roomId}&jid=${jid}&disable=true`;
      } else if (noticeScope == 1) {
        const uniqueId = `TIBAO-DAILY-${activityId}`;
        if (!ruleId || ruleId === 'undefined') {
          return `${path}${window.location.search}#/integration/yx-promotion?activityId=${activityId}&outId=${roomId}&activityType=11&uniqueId=${uniqueId}&disable=true`;
        } else {
          return `${path}${window.location.search}#/integration/yx-promotion?activityId=${activityId}&outId=${roomId}&activityType=11&uniqueId=${uniqueId}&ruleId=${ruleId}&disable=true`;
        }
      }
    },
  },
];
